import axios from 'axios'
import useSWR from 'swr'
import {
  VehicleListingResponse,
  VEHICLE_SEARCH_URL,
} from '@cinch-nx/data-search'

const fetcher = (url: string) => axios.get(url).then((res) => res.data)
/**
 * @deprecated Use the data-search-vehicles-api lib's `useSearchVehicles` hook instead
 */
export const useVehicleCount = () => {
  const URL = `${VEHICLE_SEARCH_URL}`

  const { data } = useSWR<VehicleListingResponse>(URL, fetcher)

  const vehicleCount = data?.searchResultsCount

  return { vehicleCount }
}
